import { useState } from "react";
import { Box } from "@mui/material";
import { ReactMultiEmail } from "react-multi-email";
import CloseIcon from "@mui/icons-material/Close";

import "react-multi-email/dist/style.css";

const CaltexEmailAuto = (props) => {
    const [emails, setEmails] = useState(props.value || []);
    const { onChange, field } = props;

    const onRemoveEmail = (removeEmail, index, email) => {
        removeEmail(index);

        setEmails((prev) => {
            const previous = [...prev];
            const filterItem = previous.filter((item) => item !== email);

            return filterItem;
        });
    };


    return (
        <ReactMultiEmail
            emails={emails}
            onChange={(_emails) => {
                setEmails(_emails);
                onChange(field, null, _emails);
            }}
            getLabel={(email, index, removeEmail) => {
                return (
                    <Box data-tag key={index}>
                        <Box data-tag-item sx={{ fontSize: "1rem", fontWeight: 400, color: "#333" }}>
                            {email}
                        </Box>
                        <Box component="span" data-tag-handle onClick={() => onRemoveEmail(removeEmail, index, email)}>
                            <CloseIcon sx={{ width: "15px", height: "15px" }} />
                        </Box>
                    </Box>
                );
            }}
        />
    );
};

export default CaltexEmailAuto;
